import React from "react";
import clsx from "clsx";
const estilosIcones = require('../../../estilos/icones.module.scss').default

type IconButtonsProps = {
    icon: string,
    onBotaoClicado?: () => void,
    buttonMessage?: string,
    buttonStyle?: string
}

export const IconButtons = (props: IconButtonsProps) => {

    return (
        <button type="button" onClick={props.onBotaoClicado}>
            <i className={clsx(estilosIcones.icone, "material-icons")} >{props.icon}</i>
            &nbsp;{props.buttonMessage}
        </button>
    )
}
